"use client";

import { useEffect, useState } from "react";
import { Card, Spinner, Form, Button, Row, Col } from "react-bootstrap";
import { getStoreProfile, updateStoreProfile } from "../../services/store";

const StoreProfileComp = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getStoreProfile();
        setProfile(res);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateStoreProfile(profile);
      alert("اطلاعات با موفقیت ذخیره شد");
    } catch (err) {
      console.error("خطا در ذخیره:", err);
      alert("خطا در ذخیره اطلاعات");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
        <p>در حال بارگذاری...</p>
      </div>
    );
  }

  return (
    <Card className="border-0 rounded-3">
      <Card.Body>
        <h4 className="fw-semibold mb-4">اطلاعات فروشگاه</h4>
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>نام فروشگاه</Form.Label>
                <Form.Control
                  type="text"
                  name="storeName"
                  value={profile?.storeName || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>شماره تماس</Form.Label>
                <Form.Control
                  type="text"
                  name="mobile"
                  value={profile?.mobile || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label>آدرس</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="address"
                  value={profile?.address || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Button
            type="submit"
            variant="primary"
            className="mt-4"
            disabled={saving}
          >
            {saving ? "در حال ذخیره..." : "ذخیره تغییرات"}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default StoreProfileComp;
